import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import handleValidDateTime from "../../../helpers/utils/handleValidDateTime";
import handleValidTime from "../../../helpers/utils/handleValidTime";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getEmployee, resetEmployeeState } from "../../../store/employee/action";
import { resetReimbursementState, getReimbursement as onGetReimbursements, addNewReimbursement as onAddNewReimbursement, updateReimbursement as onUpdateReimbursement, deleteReimbursement as onDeleteReimbursement, getReimbursementLoading } from "../../../store/reimbursement/action";
import { resetReimbursementTypeState, getReimbursementTypeLoading, getReimbursementType } from "../../../store/reimbursementType/action";
import { getAccAccount, resetAccAccountState } from "../../../store/accAccount/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import { api } from "../../../config";
import ModalInputFile from "../../../Components/ModalInputFile";
import defaultImg from "../../../assets/images/upload.png";
import ExportDoc from "../../../Components/Common/ExportDoc";
import { setBranchSelect, setCompanySelect } from "../../../store/actions";

const Reimbursement = () => {
  const [modal, setModal] = useState(false);
  const [modalAccPayment, setModalAccPayment] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, reimbursements, reimbursementTypes, isReimbursementCreated, isReimbursementSuccess, loading, error, employees, employeeLoading, reimbursementType, reimbursementTypeLoading, companies, companyLoading, clientLoading, clients, accAccounts, accAccountLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    reimbursements: state.Reimbursement.reimbursements,
    isReimbursementCreated: state.Reimbursement.isReimbursementCreated,
    isReimbursementSuccess: state.Reimbursement.isReimbursementSuccess,
    loading: state.Reimbursement.loading,
    employees: state.Employee.employees,
    employeeLoading: state.Employee.loading,
    error: state.Reimbursement.error,
    reimbursementTypes: state.ReimbursementType.reimbursementTypes,
    reimbursementTypeLoading: state.ReimbursementType.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clientLoading: state.Client.loading,
    clients: state.Client.clients,
    accAccounts: state.AccAccount.accAccounts,
    accAccountLoading: state.AccAccount.loading,
  }));

  const [reimbursementList, setReimbursementList] = useState([]);
  const [reimbursement, setReimbursement] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);
  const [reimbursementTypeList, setReimbursementTypeList] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isPelunasan, setIsPelunasan] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);
  const [accountingList, setAccountingList] = useState([]);

  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const [printDoc, setPrintDoc] = useState([]);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "COMPLETED", value: "3" },
        { label: "INACTIVE", value: "4" },
      ],
    },
  ];

  useEffect(() => {
    if (companySelected) {
      setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
      dispatch(resetReimbursementState());
      dispatch(onGetReimbursements({ companyId: companySelected?.value ?? "" }));
      handleGetEmployee(companySelected?.value ?? "");
      handleGetAccAccount(companySelected?.value ?? "");
    }
  }, [companySelected]);

  const handleGetEmployee = (companyId) => {
    dispatch(resetEmployeeState());
    dispatch(getEmployee({ companyId: companyId, status: 2 }));
  };

  const handleGetAccAccount = (companyId) => {
    dispatch(resetAccAccountState());
    dispatch(getAccAccount({ companyId: companyId, status: 2 }));
  };

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = selectedFiles.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setSelectedFiles(newState);
    } else {
      const index = selectedFiles.findIndex((fl) => fl.filename === file.filename);
      setSelectedFiles((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  const handleSelectFile = (file) => {
    setSelectedFiles((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    toggleMedia();
  };

  const onClickDelete = (reimbursement) => {
    setReimbursement(reimbursement);
    setDeleteModal(true);
  };

  const handleDeleteReimbursement = () => {
    if (reimbursement) {
      dispatch(onDeleteReimbursement(reimbursement));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  // useEffect(() => {
  //   setReimbursementList(reimbursements);
  // }, [reimbursements]);

  useEffect(() => {
    if (!isEmpty(reimbursements)) {
      let filteredReimbursements = reimbursements;
      if (activeTypeTab !== "all") {
        filteredReimbursements = reimbursements.filter((reimbursement) => reimbursement.reimbursement_status.name === activeTypeTab);
      }
      setReimbursementList(filteredReimbursements.map((el) => ({ ...el, isChecked: false })));
    }
  }, [reimbursements]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "reimbursement_user",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "reimbursement_type",
        label: "Kategory",
        isSelected: true,
        data: [],
      },
      {
        id: "amount",
        label: "Jumlah",
        isSelected: true,
        data: [],
      },
      {
        id: "startat",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (reimbursementList.length > 0) {
      reimbursementList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "reimbursement_user" || doc.id === "reimbursement_type") {
                doc.data.push(value?.name ?? "-");
              } else if (doc.id === "amount") {
                doc.data.push(currencyFormat(value));
              } else if (doc.id === "startat") {
                doc.data.push(handleValidDate(value));
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setPrintDoc(dataDoc);
  }, [reimbursementList]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredReimbursements = reimbursements;
      if (type !== "all") {
        filteredReimbursements = reimbursements.filter((reimbursement) => reimbursement.reimbursement_status.name === type);
      }
      setReimbursementList(filteredReimbursements);
    }
  };

  // useEffect(() => {
  //   setReimbursementList(reimbursements);
  // }, [reimbursements]);

  // useEffect(() => {
  //   if (!isEmpty(reimbursements)) setReimbursementList(reimbursements);
  // }, [reimbursements]);

  useEffect(() => {
    if (!isEmpty(employees)) {
      var data = [];
      var opt = [];
      employees.forEach((item, key) => {
        const name = item.name;
        const userId = item.userId;
        const companyId = item.companyId;
        const location = item.employee_location;
        const position = item.employee_position;
        const department = item.employee_department;
        const position_name = item?.employee_user && item?.employee_user?.user_position ? item?.employee_user?.user_position?.name : "Not set";
        var obj = {
          label: name + " - " + position_name,
          value: userId,
          companyId: companyId,
          location: location,
          position: position,
          department: department,
          userId: userId,
        };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setEmployeeList(data);
    }
  }, [employees]);

  useEffect(() => {
    if (!isEmpty(reimbursementTypes)) {
      var data = [];
      var opt = [];
      reimbursementTypes.forEach((item, key) => {
        const name = item.name;

        const id = item.id;
        var obj = {
          label: name,
          value: id,
        };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setReimbursementTypeList(data);
    }
  }, [reimbursementTypes]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(accAccounts)) {
      var data = [];
      var opt = [];
      accAccounts.forEach((item, key) => {
        const name = item.name;
        const code = item.code;
        const id = item.id;
        var obj = { label: code + " " + name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setAccountingList(data);
    }
  }, [accAccounts]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setReimbursement(null);
    } else {
      setModal(true);
    }
  }, [dispatch, modal]);

  const toggleAccPayment = useCallback(() => {
    if (modalAccPayment) {
      setModalAccPayment(false);
    } else {
      setModalAccPayment(true);
    }
  }, [modalAccPayment]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const handleReimbursementClick = useCallback(
    (arg) => {
      const data = arg;
      let files = [];
      for (const f of data.reimbursement_file) {
        files.push({ filename: f.filename, originalname: f.originalname });
      }
      setSelectedFiles(files);
      setReimbursement({
        id: data.id,
        description: data.description,
        startat: data.startat,
        endat: data.endat,
        amount: data.amount,
        employee: {
          label: data.reimbursement_user.name,
          value: data.reimbursement_user.id,
          companyId: data.reimbursement_user.companyId,
          userId: data.reimbursement_user.id,
        },
        typeId: {
          label: data.reimbursement_type.name,
          value: data.reimbursement_type.id,
        },
        client: {
          label: data.reimbursement_client.name,
          value: data.reimbursement_client.id,
        },
        company: {
          label: data.reimbursement_company.name,
          value: data.reimbursement_company.id,
        },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  const handleAccPaymentClick = useCallback(
    (arg) => {
      const data = arg;
      setReimbursement(data);
      toggleAccPayment();
    },
    [toggle]
  );

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteReimbursement(element.value));
    });
    checkall.checked = false;
  };

  const onClickApprove = (employee) => {
    setReimbursement(employee);
    setApproveModal(true);
  };

  const handleApproveEmployee = () => {
    if (reimbursement) {
      reimbursement.setApprove = true;
      dispatch(onUpdateReimbursement(reimbursement));
      setApproveModal(false);
    }
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = reimbursementList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setReimbursementList(updated);
    setIsCheckAll(allChecked);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = reimbursementList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setReimbursementList(updatedData);
                }}
              />
            </div>
          );
        },
      },
      {
        Header: " ",
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              {cellProps.row.original.statusId === 1 && (
                <>
                  <Link
                    to="#"
                    className={userType === "admin" ? "btn-icon btn btn-sm btn-light edit-item-btn" : userRole && userRole.split(",").indexOf("updateReimbursement") !== -1 ? "btn-icon btn btn-sm btn-light edit-item-btn" : "btn-icon btn btn-sm btn-light edit-item-btn d-none"}
                    onClick={() => {
                      const reimbursementData = cellProps.row.original;
                      handleReimbursementClick(reimbursementData);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Link>
                  <Link
                    to="#"
                    className={userType === "admin" ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn" : userRole && userRole.split(",").indexOf("deleteReimbursement") !== -1 ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn" : "btn-icon btn btn-sm btn-soft-danger remove-item-btn d-none"}
                    onClick={() => {
                      const reimbursementData = cellProps.row.original;
                      onClickDelete(reimbursementData);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Link>
                  <button
                    className={userType === "admin" ? "btn-label btn btn-sm btn-soft-success fs-12 me-0" : userRole && userRole.split(",").indexOf("approveReimbursement") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-0" : "btn-label btn btn-sm btn-soft-success fs-12 me-0 d-none"}
                    onClick={() => {
                      let data = cellProps.row.original;
                      onClickApprove(data);
                    }}
                  >
                    <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i> Approve
                  </button>
                </>
              )}
              {cellProps.row.original.statusId === 2 && (
                <Link
                  to="#"
                  className={userType === "admin" ? "btn btn-sm btn-soft-info fs-12 me-0" : userRole && userRole.split(",").indexOf("createLoanPayment") !== -1 ? "btn btn-sm btn-soft-info fs-12 me-0" : "btn btn-sm btn-soft-info fs-12 me-0 d-none"}
                  onClick={() => {
                    let data = cellProps.row.original;
                    handleAccPaymentClick(data);
                  }}
                >
                  <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-0"></i> Payment
                </Link>
              )}
            </div>
          );
        },
      },
      {
        Header: "Karyawan",
        accessor: "reimbursement_user.name",
        filterable: true,
      },
      {
        Header: "Kategori",
        accessor: "reimbursement_type.name",
        filterable: true,
      },
      {
        Header: "Jumlah",
        accessor: "amount",
        filterable: true,
        Cell: (rates) => <> {currencyFormat(rates.row.original.amount)} </>,
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
      },
      {
        Header: "Tanggal",
        accessor: "startat",
        filterable: true,
        Cell: (rates) => <> {handleValidDate(rates.row.original.startat)} </>,
      },
      {
        Header: "Status",
        accessor: "reimbursement_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
            case "COMPLETED":
              return <span className="badge text-uppercase badge-soft-success">{cell.value}</span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
          }
        },
      },
    ],
    [reimbursementList, handleReimbursementClick, userType, userRole, isCheckAll]
  );

  const [filterDate, setFilterDate] = useState(null);

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = reimbursementList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setReimbursementList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => reimbursementList, [reimbursementList]);
  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var reason = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      reason: reason,
      companyId: companySelected?.value ?? "",
    };
    dispatch(onGetReimbursements(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setReimbursementList([]);
    setStatusActive([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(resetReimbursementState());
    dispatch(onGetReimbursements({ companyId: companySelected?.value ?? "" }));
  };

  const validationAccPayment = useFormik({
    enableReinitialize: true,
    initialValues: {
      amount: (reimbursement && reimbursement.amount) || 0,
      account: "",
      transactionat: moment().format("YYYY/MM/DD"),
    },
    validationSchema: Yup.object({
      amount: Yup.string().required("Please Pick Amount"),
      account: Yup.object().required("Please enter payment account").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getReimbursementLoading());
      if (reimbursement) {
        reimbursement.setAccPayment = true;
        reimbursement.setApprove = false;
        reimbursement.accPaymentId = values.account.value;
        reimbursement.transactionat = values.transactionat;
        reimbursement.accType = "Reimbursement";
        reimbursement.description = `Pembayaran Reimbursement (${reimbursement.reimbursement_user.name} #${reimbursement.id})`;
        reimbursement.amount = values.amount;
        dispatch(onUpdateReimbursement(reimbursement));
      }
      validationAccPayment.resetForm();
      toggleAccPayment();
    },
  });

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      description: (reimbursement && reimbursement.description) ?? "",
      amount: (reimbursement && reimbursement.amount) || 0,
      endat: (reimbursement && reimbursement.endat) ?? "",
      startat: (reimbursement && reimbursement.startat) ?? "",
      employee: (reimbursement && reimbursement.employee) ?? "",
      typeId: (reimbursement && reimbursement.typeId) ?? "",
      client: (reimbursement && reimbursement.client) || clientSelected,
      company: (reimbursement && reimbursement.company) || companySelected,
    },
    validationSchema: Yup.object({
      // endat: Yup.string().required("Please Enter Period"),
      // startat: Yup.string().required("Please Enter Amount"),
      // employee: Yup.object().required("Please Pick employee"),
      // typeId: Yup.object().required("Please Pick Term"),
    }),
    onSubmit: (values) => {
      dispatch(getReimbursementLoading());
      dispatch(getReimbursementTypeLoading());

      if (isEdit) {
        const formData = {
          id: reimbursement ? reimbursement.id : 0,
          userId: values.employee.userId,
          typeId: values.typeId.value,
          startat: values.startat,
          endat: values.endat,
          amount: values.amount,
          clientId: values.client.value,
          companyId: values.company.value,
          files: selectedFiles.length > 0 ? selectedFiles : [],
          description: values.description,
        };
        dispatch(onUpdateReimbursement(formData));
      } else {
        const formData = {
          id: reimbursement ? reimbursement.id : 0,
          userId: values.employee.userId,
          typeId: values.typeId.value,
          startat: values.startat,
          endat: values.endat,
          amount: values.amount,
          clientId: values.client.value,
          companyId: values.company.value,
          files: selectedFiles.length > 0 ? selectedFiles : [],
          description: values.description,
        };
        dispatch(onAddNewReimbursement(formData));
      }
      validation.resetForm();
      toggle();
    },
  });

  document.title = "Pengembalian | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={reimbursementList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteReimbursement} onCloseClick={() => setDeleteModal(false)} />
      <ApproveModal data={reimbursement && reimbursement.reimbursement_employee ? reimbursement.reimbursement_employee.name + " - " + reimbursement.rates : ""} show={approveModal} onApproveClick={handleApproveEmployee} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Keuangan" pageTitle="Klaim Reimbursement" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createReimbursement") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setReimbursement("");
                setIsEdit(false);
                setIsPelunasan(false);
                toggle();
              }}
            >
              <i className="ri-wallet-3-line me-1 align-bottom fs-14"></i>Tambah
            </button>
            <ExportDoc data={printDoc} />
            {/* <button
                      className="btn btn-soft-danger"
                      onClick={() => setDeleteModalMulti(true)}>
                      <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i>      Delete
                    </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card id="reimbursementList">
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-wallet-3-line me-1 align-bottom fs-14"></i> SEMUA PENGEMBALIAN
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "COMPLETED");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> COMPLETED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "5" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("5", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={4}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3} className="col-xxl-3">
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                value={filterDate}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>

                          <Col sm={3} className="col-xxl-2">
                            <div className="me-2 mb-2 col-12">
                              <Select
                                placeholder="Pilih Status"
                                onChange={(e) => {
                                  setStatusActive(e);
                                }}
                                options={statusActiveData}
                                name="choices-single-default"
                              ></Select>
                            </div>
                          </Col>

                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th {...column.getSortByToggleProps()} className={"" + generateFilterable(column)} key={index}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Ubah Pengembalian" : "Tambah Pengembalian"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3">
                          <Label htmlFor="client-field" className="form-label">
                            Grup Usaha&nbsp;
                            {clientLoading && (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            )}
                          </Label>
                          <Select
                            name="client"
                            value={validation.values.client}
                            isDisabled={userType === "admin" || userType === "client" ? false : true}
                            placeholder="Pilih Grup Usaha"
                            onChange={(e) => {
                              validation.setFieldValue("client", e);
                            }}
                            options={clientList}
                          ></Select>
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="company-field" className="form-label">
                            Perusahaan&nbsp;
                            {companyLoading && (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            )}
                          </Label>
                          <Select
                            name="company"
                            value={validation.values.company}
                            placeholder="Pilih Perusahaan"
                            isDisabled={userType === "admin" || userType === "client" ? false : true}
                            onChange={(e) => {
                              dispatch(setBranchSelect(null));
                              dispatch(setCompanySelect(e));
                              validation.setFieldValue("company", e);
                              handleGetEmployee(e.value);
                            }}
                            options={companyList}
                          ></Select>
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="employee" className="form-label">
                            Karyawan
                            {employeeLoading && (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            )}
                          </Label>
                          <Select
                            name="employee"
                            value={validation.values.employee}
                            placeholder="Enter Employee"
                            onChange={(e) => {
                              validation.setFieldValue("employee", e);
                              setReimbursementTypeList([]);
                              dispatch(resetReimbursementTypeState());
                              dispatch(
                                getReimbursementType({
                                  companyId: e.companyId,
                                  status: 2,
                                })
                              );
                            }}
                            options={employeeList}
                            invalid={validation.touched.employee && validation.errors.employee ? true : false}
                          ></Select>
                          {validation.touched.employee && validation.errors.employee ? (
                            <p className="text-danger" type="invalid">
                              {validation.errors.employee}
                            </p>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="typeId" className="form-label">
                            Tipe Pengembalian
                            {reimbursementTypeLoading && (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            )}
                          </Label>
                          <Select
                            name="typeId"
                            value={validation.values.typeId}
                            placeholder="Enter Reimbursement Type"
                            onChange={(e) => {
                              validation.setFieldValue("typeId", e);
                            }}
                            options={reimbursementTypeList}
                            invalid={validation.touched.typeId && validation.errors.typeId ? true : false}
                          ></Select>
                          {validation.touched.typeId && validation.errors.typeId ? (
                            <p className="text-danger" type="invalid">
                              {validation.errors.typeId}
                            </p>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="amount-field" className="form-label">
                            Jumlah
                          </Label>
                          <Input name="amount" id="amount-field" className="form-control" placeholder="Enter amount" type="number" onFocus={(e) => e.target.select()} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.amount || 0} invalid={validation.touched.amount && validation.errors.amount ? true : false} />
                          {validation.touched.amount && validation.errors.amount ? <FormFeedback type="invalid">{validation.errors.amount}</FormFeedback> : null}
                        </div>
                        <div className="mb-3 col">
                          <Label>Tanggal Mulai</Label>
                          <div className={"input-group"}>
                            <Flatpickr
                              name="startat"
                              className="form-control"
                              placeholder="From date"
                              options={{ enableTime: false, time_24hr: false, altInput: false, altFormat: "Y/m/d", dateFormat: "Y/m/d" }}
                              value={validation.values.startat ?? ""}
                              onChange={(obj, str) => {
                                validation.setFieldValue("startat", str);
                              }}
                            />
                            {validation.touched.startat && validation.errors.startat ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.startat}
                              </small>
                            ) : null}
                            <span className="input-group-text">
                              <i className="ri-calendar-event-line"></i>
                            </span>
                          </div>
                        </div>
                        <div className="mb-3 col">
                          <Label>Tanggal Selesai</Label>
                          <div className={"input-group"}>
                            <Flatpickr
                              name="endat"
                              className="form-control"
                              placeholder="End date"
                              options={{ enableTime: false, time_24hr: false, altInput: false, altFormat: "Y/m/d", dateFormat: "Y/m/d" }}
                              value={validation.values.endat ?? ""}
                              onChange={(obj, str) => {
                                validation.setFieldValue("endat", str);
                              }}
                            />
                            {validation.touched.endat && validation.errors.endat ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.endat}
                              </small>
                            ) : null}
                            <span className="input-group-text">
                              <i className="ri-calendar-event-line"></i>
                            </span>
                          </div>
                        </div>
                        <div className="mb-3 d-flex justify-content-between">
                          <Label htmlFor="taskFiles" className="form-label me-3">
                            File Pengembalian
                          </Label>
                          <button
                            type="button"
                            className="btn btn-sm btn-label btn-soft-success"
                            onClick={() => {
                              toggleMedia();
                            }}
                          >
                            <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                          </button>
                        </div>
                        {selectedFiles.map((productFile, i) => {
                          if (productFile.isDeleted) {
                            return null;
                          } else {
                            return (
                              <div key={i} className="border-bottom mb-3">
                                <div className="d-flex justify-content-between mb-3 align-items-center">
                                  <div className="me-2">
                                    <img src={productFile.filename === "" ? defaultImg : `${api.MEDIA_URL}/media/${productFile.filename}-w-150`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                  </div>

                                  <div className="text-truncate">{productFile.filename}</div>
                                  <div>
                                    <Link
                                      to="#"
                                      className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                      onClick={(e) => {
                                        // e.stopPropagation();
                                        handleDeleteFile(productFile);
                                      }}
                                    >
                                      <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        })}
                        <div className="mb-4">
                          <Label htmlFor="description-field" className="form-label">
                            Keterangan
                          </Label>
                          <Input name="description" id="description-field" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">Simpan</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="reason">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

                <Modal id="showModalAccPayment" isOpen={modalAccPayment} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleAccPayment}>
                    Pembayaran Pengembalian
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationAccPayment.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="amount-field" className="form-label">
                            Jumlah
                          </Label>
                          <Input name="amount" id="amount-field" className="form-control" placeholder="Enter amount" type="number" onFocus={(e) => e.target.select()} onChange={validationAccPayment.handleChange} onBlur={validationAccPayment.handleBlur} value={validationAccPayment.values.amount || 0} invalid={validationAccPayment.touched.amount && validationAccPayment.errors.amount ? true : false} />
                          {validationAccPayment.touched.amount && validationAccPayment.errors.amount ? <FormFeedback type="invalid">{validationAccPayment.errors.amount}</FormFeedback> : null}
                        </div>
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="amount-field" className="form-label">
                            Tanggal Transaksi
                          </Label>
                          <Flatpickr
                            className="form-control"
                            id="datepicker-publish-input"
                            placeholder="Select transaction date"
                            options={{
                              mode: "single",
                              dateFormat: "Y/m/d",
                            }}
                            onChange={(selectedDates, dateStr) => {
                              validationAccPayment.setFieldValue("transactionat", dateStr);
                            }}
                            value={validationAccPayment.values.transactionat ?? ""}
                          />
                        </div>
                        <div className="mb-3 col-lg-12">
                          <label className="form-label" htmlFor="account">
                            Akun Pembayaran
                          </label>
                          <Select
                            name="account"
                            value={validationAccPayment.values.account}
                            placeholder="Enter account"
                            onChange={(e) => {
                              validationAccPayment.setFieldValue("account", e);
                            }}
                            options={accountingList}
                          ></Select>
                          {validationAccPayment.touched.account && validationAccPayment.errors.account && (
                            <small className="text-danger" type="invalid">
                              {validationAccPayment.errors.account}
                            </small>
                          )}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalAccPayment(false);
                            validationAccPayment.resetForm();
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">SIMPAN PEMBAYARAN</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Reimbursement;
